<template>
  <div>
    <div class="form-group selectreport" id="job">
      <div class="model-list">
        <button
          @click="toggleModel()"
          rel="togglebtnModel"
          ref="togglebtnModel"
          class="btn toggle-model"
        >
          <span>
            <i class="fa fa-th-large" aria-hidden="true"></i>
          </span>
          <b>Select a model</b>
        </button>

        <div class="dropdown-content hide-model-content" ref="toggleModelMenu">
          <p
            v-for="(job, key) in job"
            :key="key"
            v-bind:value="job.unique_id"
            v-bind:selected="jobselect_unique_id === job.unique_id ? true : false"
            v-on:click="selectedJob(job.id, job.unique_id, job.name);toggleModel()"
            v-bind:class="jobselect_unique_id === job.unique_id ? 'current-model' : ''"
          >{{ job.name }} | {{job.id}}</p>
        </div>
      </div>
      <div class="model-name">{{ currentJobname }} | {{ jobselect }}</div>
      <!-- <label>Select a report</label>
      <div class="select">
        <select
          ref="selectjob"
          class="form-control sjobr"
          v-on:change="selectedJob(jobselect, jobselect_unique_id)"
          v-model="jobselect_unique_id"
          data-vv-name="job"
          name="job"
        >
          <option value="null" disabled="disabled">Please select a report</option>
          <option
            v-for="(job, key) in job"
            v-bind:value="job.unique_id"
            v-bind:selected="jobselect_unique_id === job.unique_id ? true : false"
            :key="key"
          >{{ job.name }}</option>
        </select>
      </div>-->
    </div>
    <div class="stepsNav tabs">
      <a v-on:click="setstep('step1')" v-bind:class="{ active: step1 }">Model Report</a>
      <a
        v-if="wrs === 1"
        v-on:click="setstep('step2')"
        v-bind:class="{ active: step2 }"
      >Weekly Report</a>
      <a
        v-if="crs === 1"
        v-on:click="setstep('step3')"
        v-bind:class="{ active: step3 }"
      >Credit Flow Report</a>
    </div>
    <!-- <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert> -->
    <section class="content step1" v-show="step1">
      <div class="downcsv downcsvMrep col-md-2">
        <a
          ref="downcsvtriggerModel"
          v-if="downcsvMrep.length"
          v-bind:href="downcsvMrep"
          class="btn btn-lrg btn-primary downcsvtrigger"
          download
        >
          <i class="fa fa-file-excel-o"></i> Download CSV
        </a>
      </div>
      <vue-good-table
        ref="jobtable2"
        @on-selected-rows-change="onPageChange2"
        mode="local"
        v-if="jobselect_unique_id.length !== 0"
        styleClass="table table-bordered condensed"
        :columns="columns"
        :rows="rows"
        :paginate="false"
        :lineNumbers="true"
        :perPage="22"
        :sortable="true"
        :globalSearch="false"
        name="test"
      >
        <template slot="loadingContent">
          <span class="vgt-loading__content">
            <div class="dataspinner">
              <span>Loading Data</span>
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </span>
        </template>
      </vue-good-table>
    </section>
    <div class="step2 clearfix" v-show="step2">
      <div class="downcsv col-md-2 downcsvWSR">
        <a
          ref="downcsvtrigger"
          class="btn btn-lrg btn-primary downcsvtrigger"
          v-bind:href="downcsvWRS"
          v-if="downcsvWRS.length"
          download
        >
          <i class="fa fa-file-excel-o"></i> Download CSV
        </a>
      </div>
      <div class="form-group selectchannel col-md-6">
        <label>Select a Channel</label>
        <div class="select">
          <select
            class="form-control"
            v-on:change="selectedChannel(selchannels, 'wrs')"
            v-model="selchannels"
            data-vv-name="channels"
            name="channels"
          >
            <option
              v-for="ofthechannels in ofthechannels"
              v-bind:value="ofthechannels"
              v-bind:key="ofthechannels.key"
            >{{ ofthechannels }}</option>
          </select>
        </div>
      </div>
      <div class="chartWrapper" v-if="selchannels.length !== 0 && selchannels !== 'all_channels'">
        <div class="forecast_charts">
          <vue-chart
            data-vv-name="weeklyreport"
            name="weeklyreport"
            ref="weeklyreport"
            type="bar"
            :data="chartData"
            :options="chartoptions"
            :bind="true"
            :width="width"
            :height="height"
          ></vue-chart>
        </div>
      </div>
    </div>
    <div class="step3 clearfix" v-show="step3">
      <div class="downcsv col-md-2 downcsvCFR">
        <a
          ref="downcsvtrigger"
          class="btn btn-lrg btn-primary downcsvtrigger"
          v-bind:href="downcsvCRS"
          v-if="downcsvCRS.length"
          download
        >
          <i class="fa fa-file-excel-o"></i> Download CSV
        </a>
      </div>
      <div class="form-group selectchannel col-md-6">
        <label>Select a Last Click Channel</label>
        <div class="select">
          <select
            class="form-control"
            v-on:change="selectedChannel(selchannels, 'crs')"
            v-model="selchannels"
            data-vv-name="channels"
            name="channels"
          >
            <option
              v-for="ofthechannels in ofthechannels"
              v-bind:value="ofthechannels"
              v-bind:key="ofthechannels.key"
            >{{ ofthechannels }}</option>
          </select>
        </div>
      </div>
      <div class="chartWrapper" v-if="selchannels.length !== 0 && selchannels !== 'all_channels'">
        <div class="forecast_charts">
          <vue-chart
            data-vv-name="creditflowreport"
            name="creditflowreport"
            ref="creditflowreport"
            type="bar"
            :chart-data="creditflowchartData"
            :data="creditflowchartData"
            :options="creditflowchartoptions"
            :bind="true"
            :width="width"
            :height="height"
          ></vue-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import $ from 'jquery'
var jQuery = $
// Require needed datatables modules
// import _ from "lodash"
import VueGoodTable from '../../../node_modules/vue-good-table/src/components/Table.vue'
// import Simplert from "vue2-simplert"
var userchk = window.localStorage.getItem('user')
// var weeklyrepottmp = require('../../../static/json/weeklyreport.json')

import Vue from 'vue'
import Chart from 'chart.js'
import VueChart from 'vue-chart-js'
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
// import zoom from "chartjs-plugin-zoom"
// console.log(weeklyrepottmp)
import JsonExcel from './JsonExcel.vue'
Vue.component('Bar-chart', {
  extends: VueChart.Bar,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, this.chartoptions)
    this.renderChart(this.creditflowchartData, this.creditflowchartoptions)
  },
  watch: {
    creditflowchartData: function () {
      this._chart.destroy()
      this.renderChart(this.creditflowchartData, this.creditflowchartoptions)
    },
  },
})
export default {
  name: 'Tables',
  components: {
    VueGoodTable,
    // Simplert,
    VueChart,
    downloadExcel: JsonExcel,
  },
  data () {
    return {
      currentJobname: '',
      downcsvMrep: '',
      downcsvWRS: '',
      downcsvCRS: '',
      wrs: 0,
      crs: 0,
      weeks: [],
      bayesian: [],
      reporttypetodisplay: '',
      lastclick: [],
      tableLoading: true,
      loading: true,
      timer: 2000,
      isLoadingcompo: true,
      selchannels: '',
      dataweeklyreport: [],
      chartlabels: [],
      step1: true,
      step2: false,
      step3: false,
      width: 900,
      height: 500,
      selected: 'Clicks',
      value: 0,
      ofthechannels: [],
      chartData: [],
      creditflowchartData: [],
      chartoptions: {
        responsive: true,
        maintainAspectRatio: true,
        layout: {
          padding: {
            left: 5,
            right: 5,
            top: 10,
            bottom: 10,
          },
        },
        animation: {
          duration: 1000,
          easing: 'linear',
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Conversions',
                fontSize: 15,
              },
            },
          ],
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Commencing Date',
                fontSize: 15,
              },
            },
          ],
        },
        title: {
          display: true,
          text: 'Weekly Report',
          fontSize: 15,
        },
        pan: {
          // Boolean to enable panning
          enabled: false,
          speed: 2,
          threshold: 2,
          // Panning directions. Remove the appropriate direction to disable
          // Eg. 'y' would only allow panning in the y direction
          mode: 'x',
        },
        // Container for zoom options
        zoom: {
          // Boolean to enable zooming
          enabled: false,
          drag: false,
          // Zooming directions. Remove the appropriate direction to disable
          // Eg. 'y' would only allow zooming in the y direction
          mode: 'x',
          sensitivity: 4,
          limits: {
            max: 20,
            min: 1,
          },
        },
      },
      creditflowchartoptions: {
        responsive: true,
        maintainAspectRatio: true,
        layout: {
          padding: {
            left: 5,
            right: 5,
            top: 10,
            bottom: 10,
          },
        },
        animation: {
          duration: 1000,
          easing: 'linear',
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Conversion Credit Flow',
                fontSize: 15,
              },
            },
          ],
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Bayesian Model Channels',
                fontSize: 15,
              },
            },
          ],
        },
        title: {
          display: true,
          text: 'Credit Flow Report',
          fontSize: 20,
        },
        pan: {
          // Boolean to enable panning
          enabled: false,
          speed: 2,
          threshold: 2,
          // Panning directions. Remove the appropriate direction to disable
          // Eg. 'y' would only allow panning in the y direction
          mode: 'x',
        },
        // Container for zoom options
        zoom: {
          // Boolean to enable zooming
          enabled: false,
          drag: false,
          // Zooming directions. Remove the appropriate direction to disable
          // Eg. 'y' would only allow zooming in the y direction
          mode: 'x',
          sensitivity: 4,
          limits: {
            max: 20,
            min: 1,
          },
        },
      },
      job: [],
      jobselect: '',
      unique_id: '',
      jobselect_unique_id: '',
      rows: [],
      columns: [
        {
          label: 'Channel',
          field: 'channel',
          html: false,
          filterable: false,
        },
        {
          label: 'Last Click',
          field: 'last_click',
          html: false,
          filterable: false,
        },
        {
          label: 'Bayesian',
          field: 'bayesian',
          html: false,
          filterable: false,
          hidden: false,
        },
        {
          label: 'KPI',
          field: 'KPI',
          html: false,
          filterable: false,
          hidden: false,
        },
        {
          label: 'Customer Type',
          field: 'customer_type',
          html: false,
          filterable: false,
          hidden: false,
        },
      ],
    }
  },
  methods: {
    toggleModel () {
      let activeclass = this.$refs.toggleModelMenu.className.includes('hide-model-content')
      let element = this.$refs.toggleModelMenu
      let btnactive = this.$refs.togglebtnModel
      if (activeclass) {
        element.classList.remove('hide-model-content')
        element.classList.add('show-model-content')
        btnactive.classList.add('active-btn')
      } else if (!activeclass) {
        element.classList.remove('show-model-content')
        element.classList.add('hide-model-content')
        btnactive.classList.remove('active-btn')
      }
    },

    closeToggleModel () {
      let activeclass = this.$refs.toggleModelMenu.className.includes('hide-model-content')
      let element = this.$refs.toggleModelMenu
      let btnactive = this.$refs.togglebtnModel
      if (!activeclass) {
        element.classList.remove('show-model-content')
        element.classList.add('hide-model-content')
        btnactive.classList.remove('active-btn')
      }
    },
    onPageChange2 () {
      console.log('test')
      this.isLoadingcompo = false
    },
    update () {
      // this.$data._chart.update()
      // setTimeout(this.$refs.creditflowreport.chart.update(), 2000)
      // this.$refs.creditflowreport.chart.update()
    },
    triggerdwownload () {
      this.downloadCsv()
    },
    onClickFn () {
      // test
    },
    selectedChannel (chnl, type) {
      this.selchannels = chnl
      if (type === 'wrs') {
        this.displayWeeklyReport()
      } else if (type === 'crs') {
        this.displaycreditReport()
      }
    },
    agetChanneldata () {
      // this.downloadCsv()
      var self = this
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/GetChannelsForWeekly',
        data: {
          user: window.localStorage.getItem('user'),
          'job-id': self.jobselect,
          unique_id: self.jobselect_unique_id,
        },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // self.$pingpong.hideloader()
        },
        success: function (data) {
          data = JSON.parse(data['channels'])
          if (data.length === 0) {
            self.displaychannelerror()
            return
          }
          console.log(data)
          self.ofthechannels = data
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.displaypopuperr()
        },
      })
    },
    displayWeeklyReport () {
      var self = this
      if (self.selchannels === '') {
        self.selchannels = 'all_channels'
      }
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/GetWeeklyReport',
        data: {
          'user-id': window.localStorage.getItem('user'),
          'job-id': self.jobselect,
          unique_id: self.jobselect_unique_id,
          'channel-subchannel': self.selchannels,
        },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          self.$pingpong.hideloader()
          if (self.selchannels !== 'all_channels') {
            self.$refs.weeklyreport.chart.data = self.chartDataclass = 'spinner'
            self.$refs.weeklyreport.chart.update()
          }
        },
        success: function (data) {
          // console.log(data)
          // console.log('success')
          self.downcsvWRS = data.url
          data = JSON.parse(data['output'])
          if (self.selchannels !== 'all_channels') {
            self.chartData = data
            self.$refs.weeklyreport.chart.data = self.chartData
            self.$refs.weeklyreport.chart.update()
          }
          // var bgcol1 = '"backgroundColor": "#9fc54c"'
          // var bgcol2 = '"backgroundColor": "#ffdd69"'
          // self.$parent.$children[1].$children[1].chart.data = data
          if (data.length === 0) {
            self.displaychannelerror()
          }
          console.log(data)
        },
      })
    },
    displaycreditReport () {
      var self = this
      if (self.selchannels === '') {
        self.selchannels = 'all_channels'
      }
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/GetCreditFlowReport',
        data: {
          'user-id': window.localStorage.getItem('user'),
          'job-id': self.jobselect,
          unique_id: self.jobselect_unique_id,
          'channel-subchannel': self.selchannels,
        },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          self.$pingpong.hideloader()
          if (self.selchannels !== 'all_channels') {
            self.$refs.creditflowreport.chart.data = self.creditflowchartData
            self.$refs.creditflowreport.chart.update()
          }
        },
        success: function (data) {
          // console.log(data)
          // console.log('success')
          self.downcsvCRS = data.url
          if (self.selchannels !== 'all_channels') {
            data = JSON.parse(data['output'])
            self.creditflowchartData = data
          }
          // self.$parent.$children[1].$children[1].chart.data = data
          // self.$refs.creditflowreport.chart.()
          // self.$refs.creditflowreport.chart.render()
          // this.$refs.creditflowreport.chart.update()
          if (data.length === 0) {
            self.displaychannelerror()
          }
          // console.log(data)
        },
      })
      // console.log(this)
      // self.$refs.creditflowreport.chart.update()
      // setTimeout(self.$refs.creditflowreport.chart.update(), 2000)
      // this.update()
    },
    // downloadCsv(type) {
    //   var self = this
    //   console.log(type)
    //   var reportType = type
    //   var reportTypeStr
    //   if (reportType === 'wsr') {
    //     reportTypeStr = '/GetWeeklyReport'
    //   } else if (reportType === 'crs') {
    //     reportTypeStr = '/GetCreditFlowReport'
    //   }
    //   jQuery.ajax({
    //     type: 'POST',
    //     url: window.localStorage.getItem('ApiURL') + reportTypeStr,
    //     data: {
    //       'user-id': window.localStorage.getItem('user'),
    //       'job-id': self.jobselect,
    //       unique_id: self.jobselect_unique_id,
    //       'channel-subchannel': 'all_channels',
    //     },
    //     async: true,
    //     contentType: 'application/json',
    //     headers: {
    //       'x-api-key': window.localStorage.getItem('XpiKey'),
    //     },
    //     beforeSend: function() {
    //       self.$pingpong.displayLoader()
    //     },
    //     complete: function() {
    //       self.$pingpong.hideloader()
    //     },
    //     success: function(data) {
    //       // console.log(data)
    //       // console.log('success')
    //       data = JSON.parse(data['output'])
    //       var jdata = []
    //       if (data.datasets.length <= 3) {
    //         for (var i = 0; i < data.labels.length; i++) {
    //           if (reportType === 'wsr') {
    //             jdata = {
    //               week: data.labels[i],
    //               bayesian: data.datasets[0].data[i],
    //               'Last-click': data.datasets[1].data[i],
    //               'channel name': data.datasets[2].data[i],
    //               KPI: data.datasets[3].data[i],
    //               'Customer Type': data.datasets[4].data[i],
    //             }
    //             self.json_data.push(jdata)
    //           } else if (reportType === 'crs') {
    //             jdata = {
    //               'Last-click': data.labels[i],
    //               Bayesian: data.datasets[1].data[i],
    //               Revenue: data.datasets[0].data[i],
    //             }
    //             self.credit_json_data.push(jdata)
    //           }
    //           // console.log(jdata)
    //         }
    //       } else if (data.datasets.length > 3) {
    //         self.credit_json_fields = {
    //           'Last-click': 'Last-click',
    //           Bayesian: 'Bayesian',
    //           Revenue: 'Revenue',
    //           KPI: 'KPI',
    //           'Customer Type': 'Customer Type',
    //         }
    //         self.json_fields = {
    //           week: 'week',
    //           bayesian: 'bayesian',
    //           'Last-click': 'Last-click',
    //           'channel name': 'channel name',
    //           KPI: 'KPI',
    //           'Customer Type': 'Customer Type',
    //         }
    //         for (var i = 0; i < data.labels.length; i++) {
    //           if (reportType === 'wsr') {
    //             jdata = {
    //               week: data.labels[i],
    //               bayesian: data.datasets[0].data[i],
    //               'Last-click': data.datasets[1].data[i],
    //               'channel name': data.datasets[2].data[i],
    //               KPI: data.datasets[3].data[i],
    //               'Customer Type': data.datasets[4].data[i],
    //             }
    //             self.json_data.push(jdata)
    //           } else if (reportType === 'crs') {
    //             jdata = {
    //               'Last-click': data.labels[i],
    //               Bayesian: data.datasets[1].data[i],
    //               Revenue: data.datasets[0].data[i],
    //               KPI: data.datasets[2].data[i],
    //               'Customer Type': data.datasets[3].data[i],
    //             }
    //             self.credit_json_data.push(jdata)
    //           }
    //           // console.log(jdata)
    //         }
    //       }
    //       // self.$parent.$children[1].$children[1].chart.data = data
    //       if (data.length === 0) {
    //         self.displaychannelerror()
    //       }
    //       // console.log(data)
    //       // self.$refs.downcsvtrigger.click()
    //     },
    //   })
    // },
    displaypopup () {
      let obj = {
        title: 'No Model Present',
        message: 'Click on Create Model to create a new model',
        type: 'success',
        customClass: 'success',
        onClose: this.popuponClose,
        customCloseBtnText: 'Create Model',
      }
      this.$Simplert.open(obj)
    },
    displaypopuperr (msg) {
      var message = 'Click on Create Model to create a new model'
      if (msg !== undefined) {
        message = msg
      }
      let obj = {
        title: 'Server/ Data error',
        message: message,
        type: 'error',
        customClass: 'error',
        onClose: this.popuponClose,
        customCloseBtnText: 'Create Model',
      }
      this.$Simplert.open(obj)
    },
    displaychannelerror () {
      let obj = {
        title: 'No Channel Data Present',
        message: 'Click on Create Model to create a new model',
        type: 'success',
        customClass: 'success',
        onClose: this.popuponClose,
        customCloseBtnText: 'Create Model',
      }
      this.$Simplert.open(obj)
    },
    popuponClose () {
      // this.$router.push("/createjob")
      this.$router.push({ path: '/', query: { showmodel: true } })
      // this.showmodelin = true
    },
    selectedJob: function (selectedJob, uniqueid, jobname) {
      this.jobselect = selectedJob
      this.unique_id = uniqueid
      this.jobselect_unique_id = uniqueid
      this.currentJobname = jobname
      var self = this
      // var hasquerry = change
      if (self.$route.query.jid !== undefined) {
        if (self.$route.query.jid.length) {
          this.jobselect = self.$route.query.jid
          this.jobselect_unique_id = self.$route.query.uid
          this.currentJobname = self.$route.query.name
          self.$router.replace({ query: null })
          // self.selectedJob(selectedJob, 1)
        }
      }
      if (self.jobselect === undefined) {
        self.jobselect = ''
      }
      // var crrid = '$(".sjobr option[value=' + self.jobselect + ']")'
      if (self.jobselect_unique_id.length !== 0) {
        $.ajax({
          type: 'POST',
          url: window.localStorage.getItem('ApiURL') + '/GetJobOutput',
          data: {
            'user-id': userchk,
            'job-id': self.jobselect,
            unique_id: self.jobselect_unique_id,
          },
          async: true,
          contentType: 'application/json',
          headers: {
            'x-api-key': window.localStorage.getItem('XpiKey'),
          },
          beforeSend: function () {
            self.$pingpong.displayLoader()
            // $(".spinner").css({ top: "24%" })
          },
          complete: function () {
            self.$pingpong.hideloader()
            self.selchannels = ''
            // $('#job select option[value=0]').attr('selected', 'true')
          },
          success: function (data) {
            if (
              data.statusCode !== 200 ||
              data.statusCode === undefined ||
              data === undefined
            ) {
              self.$pingpong.hideloader()
              self.displaypopuperr(data.message)
            }
            // console.log(data)
            self.wrs = data.wrs
            self.crs = data.crs
            self.reporttypetodisplay = data.report_type
            self.downcsvMrep = data.url
            data = JSON.parse(data['output'])
            // console.log(data)
            self.rows = data
            if (self.reporttypetodisplay === 'last-click') {
              self.columns[2].hidden = true
            }
          },
          error: function (data, error) {
            self.$pingpong.hideloader()
            alert('data error')
          },
        })
        // crrid.attr('selected', 'selected')
      }
    },
    setstep: function (step) {
      if (step === 'step1') {
        this.step1 = true
        this.step2 = false
        this.step3 = false
      } else if (step === 'step2') {
        this.step2 = true
        this.step1 = false
        this.step3 = false
        this.selchannels = ''
        this.agetChanneldata()
        this.displayWeeklyReport()
        // this.downloadCsv('wsr')
        //this.displayWeeklyReport()
      } else if (step === 'step3') {
        this.step2 = false
        this.step1 = false
        this.step3 = true
        this.selchannels = ''
        this.agetChanneldata()
        this.displaycreditReport()
        // this.downloadCsv('crs')
        //this.displayWeeklyReport()
      }
    },
  },
  mounted () {
    let element = this.$root.$el
    element.addEventListener('click', this.closeToggleModel)
    let btnactive = this.$refs.togglebtnModel
    btnactive.addEventListener('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      return false
    })
    // this.$vm.data.datasets[0].backgroundColor = "#9fc54c"
    // this.$vm.data.datasets[1].backgroundColor = "#333"
    var self = this
    // console.log(userchk)
    userchk = window.localStorage.getItem('user')
    // console.log(userchk)
    $.ajax({
      type: 'POST',
      url: window.localStorage.getItem('ApiURL') + '/JobStatusCheck',
      data: {
        user: window.localStorage.getItem('user'),
        required: 'name, user, status',
        filter: '{"status":"completed"}',
      },
      async: true,
      contentType: 'application/json',
      headers: {
        'x-api-key': window.localStorage.getItem('XpiKey'),
      },
      beforeSend: function () {
        self.$pingpong.displayLoader()
        $('.spinner').css({ top: '14%' })
      },
      complete: function () {
        // $('#job select option[value=0]').attr('selected', 'true')
      },
      success: function (data) {
        // console.log(data)
        self.$pingpong.hideloader()
        data = JSON.parse(data['job_status_data'])
        //this.wrs = JSON.parse(data['wrs'])
        // var mydata = data[0]['name']
        // data[0]['name'] = [].concat(...mydata)
        if (data.length === 0) {
          self.displaypopup()
          return
        }
        // console.log(data)
        self.job = data
        // return data
        // self.displaypopup()
        console.log('this.$route.query.jid= ' + self.$route.query)
        if (
          (window.localStorage.getItem('jobid') !== null ||
            window.localStorage.getItem('jobid') !== 'undefined' ||
            window.localStorage.getItem('jobid') !== '') &&
          (window.localStorage.getItem('unique_id') !== null ||
            window.localStorage.getItem('unique_id') !== 'undefined' ||
            window.localStorage.getItem('unique_id') === '')
        ) {
          if (
            window.localStorage.getItem('jobid').length &&
            window.localStorage.getItem('unique_id').length
          ) {
            let selectedJob = window.localStorage.getItem('jobid')
            let selectedJobUID = window.localStorage.getItem('unique_id')
            self.selectedJob(selectedJob, selectedJobUID)
            self.jobselect_unique_id = selectedJobUID
            self.jobselect = selectedJob
            self.job.forEach(function (e, i) {
              if (e.id === selectedJob) {
                self.currentJobname = e.name
              }
            })

          }
        } else {
          console.log(data[0].id)
          self.selectedJob(data[0].id, data[0].unique_id, data[0].name)
        }
      },
      error: function (data, error) {
        // console.log(data)
        console.log(error)
        self.displaypopuperr()
      },
    })
  },
  computed: {
    creditflowchartData: {
      get: function () {
        this.$refs.creditflowreport.chart.update()
        // this.update()
      },
      set: function () {
        this.$refs.creditflowreport.chart.update()
        // this.update()
      },
    },
  },
  watch: {
    jobselect: function (newval, oldval) {
      window.localStorage.setItem('jobid', newval)
      return newval
    },
    jobselect_unique_id: function (newval, oldval) {
      window.localStorage.setItem('unique_id', newval)
      return newval
    },
    chartData: function () {
      this.$refs.weeklyreport.chart.data = this.chartData
      this.$refs.weeklyreport.chart.data.datasets[0].backgroundColor = '#deebc2'
      this.$refs.weeklyreport.chart.data.datasets[1].backgroundColor = '#98a499'
      this.$refs.weeklyreport.chart.scaleSteps = 9
      this.$refs.weeklyreport.chart.scaleStartValue = 0
      this.$refs.weeklyreport.chart.scaleStepWidth = 100
      $('canvas').focus()
    },
    creditflowchartData: function () {
      this.$refs.creditflowreport.chart.data = this.creditflowchartData
      this.$refs.creditflowreport.chart.data.datasets[0].backgroundColor =
        '#deebc2'
      this.$refs.creditflowreport.chart.data.datasets[1].backgroundColor =
        '#98a499'
      this.$refs.creditflowreport.chart.scaleSteps = 9
      this.$refs.creditflowreport.chart.scaleStartValue = 0
      this.$refs.creditflowreport.chart.scaleStepWidth = 100
      $('canvas').focus()
    },
  },
}
</script>
<style scoped>
.downcsvMrep {
  position: absolute;
  z-index: 1;
  top: -63px;
  width: 150px;
  right: 15px;
}
</style>
<style lang="scss" scoped>
.toggle-model.active-btn span,
.toggle-subchannels.active-btn span {
  background: #444;
}
.toggle-model.active-btn,
.toggle-subchannels.active-btn {
  &:hover b {
    background: #444;
  }
}
.toggle-model,
.toggle-subchannels {
  position: relative;
  background: none;

  span {
    padding: 12px 15px;
    background: #9fc54c;
    font-size: 20px;
    color: #fff;
    border-radius: 30px;
    z-index: 20;
    box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.2);
  }
  b {
    opacity: 0;
    position: absolute;
    left: 0px;
    top: 5px;
    transition: All 0.4s ease-in-out;
    transform: rotate(0deg) scale(0) skew(0deg) translate(0px);
    z-index: 1;
  }
  &:hover b {
    opacity: 1;
    display: block;
    padding: 5px;
    background: #9fc54c;
    border-radius: 4px;
    color: #fff;
    left: 0px;
    transition: All 0.2s ease-in-out;
    transform: rotate(0deg) scale(1) skew(0deg) translate(45px);
  }
}
.dropdown-content {
  margin-top: 5px;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  overflow: auto;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  border: 1px solid #9e9e9e;
  border-radius: 0px 0px 5px 5px;
}
.dropdown-content p {
  cursor: pointer;
  margin: 0;
  padding: 10px 40px 10px 10px;
  border-bottom: 1px solid #9e9e9e;
}
.dropdown-content p:hover {
  background-color: #444;
  color: #fff;
}
.dropdown-content p:last-child {
  border-bottom: none;
}
.show-model-content,
.show-subchannels-content {
  display: block;
}
.hide-model-content,
.hide-subchannels-content {
  display: none;
}
.model-list {
  display: inline;
}
.model-name {
  display: inline;
  font-size: 24px;
  width: 80%;
  position: absolute;
  text-align: center;
  font-weight: 600;
  line-height: 45px;
}
.current-model {
  background: #ededed;
  box-shadow: inset 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
}
.current-model::after {
  content: '\F00C';
  font: normal normal normal 14px/1 FontAwesome;
  position: absolute;
  right: 10px;
  padding-top: 3px;
}
</style>

<style lang='scss'>
a.displaybot {
  z-index: 21;
}
.tabs a {
  display: inline-block;
  line-height: 40px;
  background-color: #d6d6d6;
  padding: 0 20px;
  font-weight: bold;
  color: #000;
  margin-left: 10px;
  cursor: pointer;
}
.tabs a.active {
  background-color: #9fc54c;
  color: #fff;
}
.tabs {
  border-bottom: 1px solid #d6d6d6;
  margin: 20px;
}
.selectreport,
.selectchannel {
  margin: 20px 20px 0 20px;
}
.downcsv .downcsv {
  /* margin: 0 auto */
  display: block;
  text-align: center;
  a {
    font-size: 20px;
  }
  i {
    margin-right: 10px;
  }
}
.downcsvWSR,
.downcsvCFR {
  position: absolute;
  top: -62px;
  right: 6px;
  margin-bottom: 0px !important;
  width: auto !important;
}
.downcsv {
  text-align: right;
  margin: 0;
  background-color: white;
  margin-bottom: 20px;
  width: 100%;

  a {
    font-size: 14px;
    background-color: #444;
    border-color: #444;
    &:hover {
      background-color: #444;
      border-color: #444;
    }
  }
  i {
    margin-right: 5px;
  }
}
.selectchannel {
  margin: 0;
  width: 100%;
}
.step2,
.step1,
.step3 {
  position: relative;
}
.forecast_charts {
  width: 95%;
  text-align: center;
  margin: 0 auto;
}

.content-wrapper {
  padding-bottom: 15px;
}
.selectreport select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Jobdashboard.vue?6eabe9a0